export default {
    requestCode: {
        jzz: '加载中',
        qzsb: '请求失败，请稍后重试。如有疑问，请联系客服。',
        dlsxqcxdl: '登录失效，请重新登录',
        dlsxqcxjr: '登录失效，请重新进入',
        fwqzwxyqshzs: '服务器暂无响应，请稍后再试',
    },
    backStep: '上一步',
    nextStep: '下一步',
    submit: '提交',
    noAllowEmpty: '不能为空',
    bxxbnwk: '必选项不能为空',
    confirm: '确认',
    cancel: '取消',
    mmcw: '密码错误',
    reset: '重置',
    success: '完成',
    Understood: '已了解',
    已了解: '已了解',
    close: '关闭',
    service: '联系客服',
    backOpen: '返回开通',
    Step: {
        xxyz: '信息验证',
        fxpl: '风险披露',
        rlyz: '人脸验证',
        rjrz: '入金认证',
        vytzzrz: '专业人士认证',
    },
    AudioPlayer: {
        cpdb: '持牌代表：',
        pzh: '牌照号',
        bs: '倍速',
        yue: '约',
        fen: '分',
        miao: '秒',
    },
    CheckBoxList: {
        wyjydjmb: '我已经阅读及明白',
        khxys: '客户协议书',
        khsqqrs: '客户授权确认书',
        nr: '内容；',
    },
    CountryPopup: {
        qsrdqgjzss: '请输入地区关键字搜索',
        cydq: '常用地区',
    },
    Investment: {
        ynyx: '1年以下',
        yzhiwunian: '1-5年',
        liuzhishinian: '6-10年',
        shinianyishang: '10年以上',
        baoben: '保本',
        zczz: '资产增值',
        gxhb: '股息回报',
        duichong: '对冲',
        tl: '套利',
        touji: '投机',
        wyyjxyspmm: '我有意进行衍生品买卖',
        simple: {
            wyyjxyspmm: '我有意进行衍生品买卖，并了解衍生品交易中所涉及的风险',
        },
        wwyjxyspmm: '我无意进行衍生品买卖',
        jrjgjbdyspjz: '金融机构举办的衍生品讲座。',
        jyjgjbyspwskc: '教育机构举办衍生品网上课程或教室课程。',
        yhxtgs: '银行/信托公司',
        zqqhqq: '证券/期货/期权',
        jjzgjz: '基金/资管公司/家族办公室',
        jysjrhyxh: '交易所/金融行业协会',
        bxgs: '保险公司',
        ysqz: '衍生权证',
        nxz: '牛熊证',
        qhhqq: '期货和期权',
        gpggpj: '股票挂钩票据',
        yq: '远期',
        dqhh: '掉期（互换）',
        tzjy: '投资经验',
        gptzjy: '香港上市股票投资经验',
        jytzjy: '金银投资经验',
        whjsptzjy: '外汇及商品投资经验',
        agtzjy: 'A股投资经验',
        jjtzjy: '基金投资经验',
        tzmddx: '投资目的',
        khxys: '客户协议书',
    },
    DerivativeModel: {
        yspmm: '衍生品买卖',
        nsfljyscpdzytcjfx: '您是否了解衍生产品的主要特征及风险',
        wmbybyscpdzytzqlj: '我明白一般衍生产品的主要特征。且了解衍生产品的主要特征以及衍生交易中所涉及的风险。',
        nxyzsyyyxyscpxgjy: '您需要至少拥有一项衍生产品相关经验（多选）',
        wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有关介绍衍生产品之性质及风险的培训或课程。',
        wxshgwdgzjyywyyscpyg: '我现时或过往的工作经验/业务与衍生产品有关。',
        wxshgwdgzjyywyyscpygyqxgzy: '我现时或过往的工作经验/业务与衍生产品有关。与其相关职业和性质为：',
        wxshgwdyyscpygdgzjyywdfwnqw: '我现时或过往的与衍生产品有关的工作经验/业务的服务年期为：',
        wymmyscpdjymmgdyscps: '我有买卖衍生产品的经验。买卖过的衍生产品是：',
        yscpbkdbxyysqcnxzgpzsqh:
            '衍生产品包括但不限于衍生权证、牛熊证、股票/指数期货及期权、商品结构性产品及交易所基金等，无论是否于交易所进行交易。',
        nyqrwytzyscpbckh: '您已确认无意投资衍生产品，本次开户将不会开通衍生品交易权限。',
    },
    SimpleDerivative: {
        title: '您是否有意进行衍生品买卖？',
        yspmm: '衍生品买卖',
        nsfljyscpdzytcjfx: '您是否了解衍生产品的主要特征及风险',
        wmbybyscpdzytzqlj: '我明白一般衍生产品的主要特征。且了解衍生产品的主要特征以及衍生交易中所涉及的风险。',
        nxyzsyyyxyscpxgjy: '请选择您的衍生品相关经验',
        wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有关介绍衍生产品之性质及风险的培训或课程。',
        wxshgwdgzjyywyyscpyg: '我现时或过往的工作经验/业务与衍生产品有关。',
        wxshgwdgzjyywyyscpygyqxgzy: '我现时或过往的工作经验/业务与衍生产品有关。与其相关职业和性质为：',
        wxshgwdyyscpygdgzjyywdfwnqw: '我现时或过往的与衍生产品有关的工作经验/业务的服务年期为：',
        wymmyscpdjymmgdyscps: '我有买卖衍生产品的经验。',
        yscpbkdbxyysqcnxzgpzsqh:
            '衍生产品包括但不限于衍生权证、牛熊证、股票/指数期货及期权、商品结构性产品及交易所基金等，无论是否于交易所进行交易。',
        nyqrwytzyscpbckh: '您已确认无意投资衍生产品，本次开户将不会开通衍生品交易权限。',
        errorInfo: '开通衍生品权限至少需要勾选一项衍生品相关经验',
        openText: '开通衍生品权限',
    },
    UploadFile: {
        scz: '上传中...',
        jzz: '加载中...',
        scsbqcs: '上传失败，请重试',
        xztp: '选择图片',
        wjcgzdxz: '文件超过最大限制',
        zctpyupdf: '支持上传文件(PDF)、图片',
    },
    fxhlkh: '复星国际证券开户',
    idCardTip: {
        photoTips: {
            title: '拍照提示',
            des: '拍摄时请确保身份证边框完整、文字清晰可见、亮度均匀不反光',
        },
        photoError: {
            standard: '标准',
            missing: '边框缺失',
            vague: '信息模糊',
            reflex: '图片反光',
        },
    },
    passwordError: '密码错误',
    tradeDialog: {
        title: '输入交易密码',
        sure: '确定',
        tip: '8-20位数字、字母组合',
        passwordVerification: '交易密码验证',
        forgotPassword: '忘记密码',
        noticeText: '当前账户类型暂不支持此功能，如有疑问，请联系复星财富客服。',
        freezeText: '当前账户已冻结，请联系客服',
        toastFreezeText: '提交失败！账户已冻结，请联系客服。',
    },
    complianceTips: '证券相关服务由复星国际证券提供',
    firstLoginTips: '手机号首次登录将自动注册账号',
    loading: '加载中...',
    djsc: '点击上传',
    nyjxzgdqtp: '您已经选择过当前图片',
    scz: '上传中',
    yhmc: '银行名称',
    zceddakjrj: '支持eDDA快捷入金',
    zcqtrjfs: '支持其他入金方式',
    复星国际证券: '复星国际证券',
    noticeBarTip: '为保障正常使用交易功能，请阅读相关协议并授权',
    toAuth: '去授权',
    identifyTitle: '重要提醒',
    identifyText2: '尊敬的客户，您已完成「香港投资者识别码制度」相关授权，您的账户预计将于下一个工作日解除锁定，请您耐心等待。',
    questText: '如有疑问，请',
    toSign: '立即签署',
    lookDetail: '查看详情',
    submitError: '提交失败',
    openBtn: '立即开户',
    openTip: '您尚未完成开户，暂不可申购新股',
    setPasswordBtn: '设置交易密码',
    setPasswordTip: '您尚未设置交易密码，暂不可申购新股',
    repeatSendCodeTips: '60s内无须重复获取验证码',
    千: '千',
    万: '万',
    十万: '十万',
    百万: '百万',
    千万: '千万',
    亿: '亿',
    十亿: '十亿',
    signAuthTip: '请确认授权后重试',

    伴您财富乘长: '伴您财富乘长',
    音频加载中: '音频加载中',
    下载: '下载',
    downloadNow: '立即下载',
    onlineService: '在线客服',
    goToConsult: '前往咨询',
    mainlandService: '电话客服（其他）',
    hkService: '电话客服（香港）',
    welcomeService: 'Hi～很高兴为您服务',
    LivingWitness: {
        rlyz: '人脸验证',
        qasldzpsydsmbrmbsp: '请按示例动作拍摄一段3秒的本人面部视频',
        shili: '示例',
        banshenzhengmian: '半身正面视频',
        paishetishi: '拍摄提示',
        qbzmbwz: '请确保脸部完整，保持光线充足；',
        spschrbmykcxps: '视频上传后，若不满意可点击重新拍摄',
        dqllqbbbzcsxtqqhllq: '当前浏览器版本不支持摄像头，请切换浏览器',
        yzsbqcxyz: '验证失败，请重新验证',
        lzspsbqcxlz: '录制视频失败，请重新录制',
        qzydddkym: '请在移动端打开页面',
        rlyztg: '人脸验证通过',
        spwjgdqcxsc: '视频文件过大，请重新上传',
        htsbtp: '活体识别图片',
        videoShortMsg: '视频过短，请重新上传',
        videoLongMsg: '视频过长，请重新上传',
        uploadSuccessMsg: '上传成功',
        yuji: '预计',
        status_calculating: '正在计算文件校验码...',
        status_init: '初始化',
        status_uploading: '正在上传...',
        status_completing: '正在处理文件...',
        status_done: '上传完成',
        status_verifying: '认证中',
        vidioLargeTip: '当前上传视频过大，请您前往App进行开户。如有疑问，请联系客服',
    },

    tishi: '提示',
    提示: '提示',
    submitSuccess: '提交成功',
    我已确认自愿签署: '我已确认自愿签署',
    '《复星国际证券有限公司客户说明文件》': '《复星国际证券有限公司客户说明文件》',
    复星国际证券有限公司客户说明文件: '复星国际证券有限公司客户说明文件',
    美股期权交易风险披露声明: '《美股期权交易-风险披露声明》',
    enterpriseWechatCustomerService: '企业微信客服',
    generatingQrCode: '二维码生成中...',
    qeCodeGenerationFailed: '二维码生成失败',
    longPressQRCode: '长按二维码保存',
    longPressNotRecognized: '长按无法识别？',
    longPressTip: '请长按保存二维码到您的手机相册， 打开微信使用扫一扫功能，从相册中选择刚才保存的二维码图片识别，即可成功加入群聊。',
    hkCustomerServiceHotline: '香港客服电话',
    mainlandCustomerServiceHotline: '大陆客服电话',
    weChatBusiness: '企业微信',
    relatedInquiriesPleaseContactCustomerService: '相关咨询可联系客服',
    ContactCustomerService: '联系客服',
    customerService: '客服电话',
    riskDisclosureAllow: '本人同意',
    yzmfssb: '验证码发送失败',
    riskDisclosureElectronAllowFileName: '《电子签名的同意书》',
    riskDisclosureElectronDesc:
        '，通过输入交易密码及一次性短信验证码等电子方式，以进行{name}确认及签署文件。本人明白此电子签署方式符合香港《电子交易条例》（第553章）规定，并与本亲笔签名具有同等法律效力。',
    bzcxskf: '抱歉，当前所选国家/地区暂不支持线上开户，如需办理请',
    xxcl: '进行线下处理。',
    bzcxskfxg: '抱歉，当前所选国家/地区暂不支持线上修改账户资料，如需办理请',
}
